import React, { useContext, Fragment } from 'react';

import classNames from 'classnames';

import { PageContext } from '../../context/PageContext';

import * as classes from './style.module.scss';

interface Props {
  className?: string;
}

export const Breadcrumbs: React.FC<Props> = ({ className }) => {
  const { breadcrumbs } = useContext(PageContext);

  return (
    <div className={classNames(classes.root, className)}>
      {breadcrumbs.map((crumb, index) => (
        <Fragment key={crumb}>
          <span>{crumb}</span>
          {index !== breadcrumbs.length - 1 && <span>/</span>}
        </Fragment>
      ))}
    </div>
  );
};
